/// <amd-module name="VSS/Redux/Modules/TTIMonitor/TTIMonitorReducer" />
import produce from "immer";
import { TTIMonitorActions } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorActions";
import { TTIMonitorActionTypes } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorActions";
import { ITTIMonitorState } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorContracts";

export function ttiMonitorReducer(state: ITTIMonitorState, action: TTIMonitorActions): ITTIMonitorState {
    state = state || { isPageInteractive: false };
    return produce(state, draft => {
        switch (action.type) {
            case TTIMonitorActionTypes.SetTTIState: {
                draft.isPageInteractive = true;
                break;
            }
        }
    });
}
